import { useEffect } from "react";
import Traceability from '../table/Tabletraceability';



const Dashboard = () => {
  useEffect(() => {
    // getPromise(["sales", "purchases"]);
  }, []);


  return (
    <>
    
    <Traceability/>
    
     
     </>
  );
};

export default Dashboard;
